// ===============================================================================
//
//  This file contains the class containing all the pathnames for surveys
//
// ===============================================================================

export class BulkReportComponentPaths {
    // ===============================================================================

    public static readonly BasePath: string = '/BulkReport';
}